/** Mail owns current domain authority; absent optional fields retain the legacy contract. */
export type MailDomainReadiness={ready:boolean;canCreateMailbox?:boolean;ownershipClaimed?:boolean;receiveReady?:boolean;sendReady?:boolean;warnings?:string[]};
export function validMailDomainReadiness(value:unknown):value is MailDomainReadiness {
 if(!value||typeof value!=='object')return false;
 const d=value as Record<string,unknown>;
 if(typeof d.ready!=='boolean')return false;
 for(const field of ['canCreateMailbox','ownershipClaimed','receiveReady','sendReady'])if(d[field]!==undefined&&typeof d[field]!=='boolean')return false;
 return d.warnings===undefined||(Array.isArray(d.warnings)&&d.warnings.every(w=>typeof w==='string'));
}
export function canCreateMailbox(domain:MailDomainReadiness):boolean {
 return domain.canCreateMailbox===undefined?domain.ready===true:domain.canCreateMailbox===true;
}
